// removed by extract-text-webpack-plugin
module.exports = {"floatBox":"_1cA7EzPA8g-5VJqnul9K4Y","arrow":"_2GKCiS2XIK700w2mYZsZtv","active":"_1RIvshOHTjMIuFuzPWTQn"};


//////////////////
// WEBPACK FOOTER
// ./src/components/atoms/FloatBox/style.css
// module id = 226
// module chunks = 42